import { Component } from 'react';
import * as _ from 'lodash';
import { IConnectToDonorStatus, IDashRegistrationLog, IDonorConnect, IListItem } from '@nkr/models/index';
import { Button, Glyphicon, Label, Panel, Well } from 'react-bootstrap';
import LogEntry from './log-entry';
import { ICounselor } from './models';
import DeleteLogEntryConfirmation from './delete-log-entry-confirmation';
import ReactHtmlParser from 'react-html-parser';

interface IProps {
    data: IDonorConnect,
    statusList: IConnectToDonorStatus[],
    actionList: IListItem[],
    userList: ICounselor[],
    container: any,
    isMobile: boolean,
    onSaveLogEntry: (id: number, dashRegistrationId: number, actionTaken: number, comments: string, isPinned: boolean) => void,
    onDeleteLogEntry: (id: number, dashRegistrationId: number) => void
}

interface IState {
    addEdit: {
        show: boolean,
        data: IDashRegistrationLog
    },
    delete: {
        show: boolean,
        data: IDashRegistrationLog
    }
}

class Log extends Component<IProps, IState> {
    readonly state: IState = {
        addEdit: {
            show: false,
            data: null
        },
        delete: {
            show: false,
            data: null
        }
    }

    handleShowAddEdit = (data: IDashRegistrationLog) => {
        this.setState({
            addEdit: {
                show: true,
                data
            }
        });
    }

    handleCancelAdd = () => {
        this.setState({
            addEdit: {
                show: false,
                data: null
            }
        });
    }

    handelSaveLogEntry = (actionTaken: number, comments: string, isPinned: boolean) => {
        let { id: dashRegistrationId } = this.props.data;
        let id = this.state.addEdit.data != null ? this.state.addEdit.data.id : 0;

        this.props.onSaveLogEntry(id, dashRegistrationId, actionTaken, comments, isPinned);

        this.setState({
            addEdit: {
                show: false,
                data: null
            }
        });
    }

    handleConfirmDeleteLogEntry = (data: IDashRegistrationLog) => {
        this.setState({
            delete: {
                show: true,
                data
            }
        });
    }

    handleCancelDeleteLogEntry = () => {
        this.setState({
            delete: {
                show: false,
                data: null
            }
        });
    }

    handleDeleteLogEntry = () => {
        let { id: dashRegistrationId } = this.props.data;
        let id = this.state.delete.data.id;

        this.props.onDeleteLogEntry(id, dashRegistrationId);

        this.setState({
            delete: {
                show: false,
                data: null
            }
        });
    }

    render = () => {
        const logList1 = _.orderBy(this.props.data.logs, item => {
            if (item.updateDateTime != '') {
                return new Date(item.updateDateTime);
            } else {
                return new Date(item.logDateTime);
            }
        }, ['desc']);


        const logList = _.orderBy(
            this.props.data.logs,
            [item => item.isPinned == true ? 1 : 0, item => new Date(item.updateDateTime || item.logDateTime)],
            ['desc', 'desc']
        );


        return (
            <>
                {/* <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 10, marginBottom: 5 }}>
                    <h3 style={{ margin: 0 }}>Logs</h3>
                    <Button bsStyle='link' onClick={() => this.handleShowAddEdit(null)}>Add Log Entry</Button>
                </div> */}

                {this.state.addEdit.show && (
                    <LogEntry
                        data={this.state.addEdit.data}
                        actionList={this.props.actionList}
                        onSave={this.handelSaveLogEntry}
                        onCancel={this.handleCancelAdd}
                    />
                )}

                <Panel>
                    <Panel.Heading>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <div>Logs</div>
                            <Button bsStyle='primary' bsSize='xs' onClick={() => this.handleShowAddEdit(null)}>Add Log Entry</Button>
                        </div>
                    </Panel.Heading>

                    <Panel.Body style={{ padding: 0 }}>
                        <div style={{ height: this.props.isMobile == false ? '48vh' : 300, overflowY: 'scroll', border: this.props.isMobile == false ? '1px solid lightblue' : null, padding: 5 }}>
                            {logList.map(log =>
                                <Well key={'log-' + log.id} style={{ padding: 7, marginBottom: 5 }}>
                                    <div style={{ marginBottom: 15, display: 'flex', justifyContent: 'space-between' }}>
                                        <div>
                                            {log.updateDateTimeForDisplay != '' && (
                                                <div><Label bsStyle='info' style={{ color: 'black' }}>Updated {log.updateDateTimeForDisplay} By {log.updatedByFullName}</Label></div>
                                            )}
                                            <div><Label bsStyle='primary'>Created {log.logDateTimeForDisplay} By {log.createdByFullName}</Label></div>
                                        </div>
                                        {log.isPinned && (
                                            <Glyphicon glyph='pushpin' style={{ color: 'green' }} title="This log entry has been marked as pinned" />
                                        )}
                                        {log.isEditable == false && log.isDeletable == false && (
                                            <Glyphicon glyph='lock' style={{ color: 'darkred' }} title="This is a system generated log entry and can't be edited nor deleted" />
                                        )}
                                    </div>

                                    {(log.isEditable || log.isDeletable) && (
                                        <h4 style={{ marginBottom: 10 }}>
                                            <Label >{log.actionTaken}</Label>
                                        </h4>
                                    )}

                                    <div style={{ backgroundColor: 'white', border: '1px solid #ddd', borderRadius: 4, padding: 5, marginBottom: 5 }}>{ReactHtmlParser(log.comments.replace(/(?:\r\n|\r|\n)/g, '<br/>'))}</div>

                                    <div className='text-right'>
                                        {log.isEditable && (
                                            <Button bsSize='sm' style={{ marginRight: 5 }} title='Edit this log entry...' onClick={() => this.handleShowAddEdit(log)}>
                                                <Glyphicon glyph='edit' />
                                            </Button>
                                        )}

                                        {log.isDeletable && (
                                            <Button bsSize='sm' title='Delete this log entry...' onClick={() => this.handleConfirmDeleteLogEntry(log)}>
                                                <Glyphicon glyph='trash' />
                                            </Button>
                                        )}
                                    </div>
                                </Well>
                            )}

                            {this.props.data.logs.length == 0 && (
                                <Well>
                                    No log entries have been added yet....
                                </Well>
                            )}
                        </div>
                    </Panel.Body>
                </Panel>

                <DeleteLogEntryConfirmation
                    show={this.state.delete.show}
                    data={this.state.delete.data}
                    container={this.props.container}
                    onDelete={this.handleDeleteLogEntry}
                    onCancel={this.handleCancelDeleteLogEntry}
                />
            </>
        );
    }
}

export default Log;